<template>

    <div class="step-content">
        <div class="intro-block">
            <h5 class="txt-grt">Your Payment Data</h5>
            <p>The first payment will be charged at the end of your one-month&nbsp;free&nbsp;trial</p>
        </div>
        <div class="step-inner-content">
            <InputWrapper placeholder="Name on your card"></InputWrapper>
            <InputWrapper placeholder="Card number"></InputWrapper>
            <div class="split-input">
                <InputWrapper placeholder="01/2020"></InputWrapper>
                <InputWrapper placeholder="CVC" :max-chars="3"></InputWrapper>
            </div>
            <div class="nxt-out">
                <div class="bgout"></div>
                <router-link tag="div" to="/services" class="btn bck">
                    <span class="txt">Back</span>
                </router-link>
                <router-link tag="div" to="/congrats" class="btn main txt-blk">
                    <span class="hvr"></span>
                    <span class="txt">Finish</span>
                </router-link>
            </div>
        </div>
    </div>

</template>

<script>

    import InputWrapper from '../../components/InputWrapper'

    export default {

        name: 'F',

        components: {
            InputWrapper
        },

        data() {
            return {
            }
        }
    }
</script>